import {
  FAILURE_CREATE_SEGMENT_GROUP,
  FAILURE_FETCH_SEGMENT_GROUPS,
  FAILURE_INACTIVATE_SEGMENT_GROUP,
  FAILURE_SORT_SEGMENT_GROUP,
  FAILURE_UPDATE_SEGMENT_GROUP,
  REQUEST_CREATE_SEGMENT_GROUP,
  REQUEST_FETCH_SEGMENT_GROUPS,
  REQUEST_INACTIVATE_SEGMENT_GROUP,
  REQUEST_SORT_SEGMENT_GROUP,
  REQUEST_UPDATE_SEGMENT_GROUP,
  RESET_SEGMENT_GROUPS_STATE,
  SET_ACTIVE_SEGMENT,
  SUCCESS_CREATE_SEGMENT_GROUP,
  SUCCESS_FETCH_SEGMENT_GROUPS,
  SUCCESS_INACTIVATE_SEGMENT_GROUP,
  SUCCESS_SORT_SEGMENT_GROUP,
  SUCCESS_UPDATE_SEGMENT_GROUP,
} from 'actions/actionTypes';
import {
  BackendSegmentActionTypes,
  BackendSegmentState,
  SegmentGroupTypes,
} from 'types/backend/segment';

export const initialState: BackendSegmentState = {
  segmentGroups: [],
  activeSegmentType: 'department',
  activeSegmentGroups: [],
  isFetchingSegmentGroups: true,
};

const backendSegmentReducer = (
  state = initialState,
  action: BackendSegmentActionTypes,
): BackendSegmentState => {
  switch (action.type) {
    case RESET_SEGMENT_GROUPS_STATE: {
      return {
        ...state,
        segmentGroups: initialState.segmentGroups,
        activeSegmentType: initialState.activeSegmentType,
        activeSegmentGroups: initialState.activeSegmentGroups,
      };
    }
    case REQUEST_FETCH_SEGMENT_GROUPS: {
      return {
        ...state,
        isFetchingSegmentGroups: true,
      };
    }
    case SUCCESS_FETCH_SEGMENT_GROUPS: {
      const { payload } = action;

      const activeSegmentGroups = payload.filter((segmentGroup: SegmentGroupTypes) => {
        return segmentGroup.segmentType === initialState.activeSegmentType;
      });

      return {
        ...state,
        segmentGroups: payload,
        activeSegmentGroups,
        isFetchingSegmentGroups: false,
      };
    }
    case FAILURE_FETCH_SEGMENT_GROUPS: {
      return {
        ...state,
        isFetchingSegmentGroups: false,
      };
    }
    case SET_ACTIVE_SEGMENT: {
      const { segmentType } = action;

      const newActiveSegmentGroups = state.segmentGroups.filter((segmentGroups) => {
        return segmentGroups.segmentType === segmentType;
      });

      return {
        ...state,
        activeSegmentType: segmentType,
        activeSegmentGroups: newActiveSegmentGroups,
      };
    }
    case REQUEST_CREATE_SEGMENT_GROUP: {
      return {
        ...state,
      };
    }
    case SUCCESS_CREATE_SEGMENT_GROUP: {
      const { payload } = action;

      const segmentGroups = [...state.segmentGroups, payload];
      const activeSegmentGroups = segmentGroups.filter((segmentGroup: SegmentGroupTypes) => {
        return segmentGroup.segmentType === state.activeSegmentType;
      });

      return {
        ...state,
        segmentGroups,
        activeSegmentGroups,
      };
    }
    case FAILURE_CREATE_SEGMENT_GROUP: {
      return {
        ...state,
      };
    }
    case REQUEST_UPDATE_SEGMENT_GROUP: {
      return {
        ...state,
      };
    }
    case SUCCESS_UPDATE_SEGMENT_GROUP: {
      const { payload } = action;

      const newSegmentGroups = state.segmentGroups.map((segmentGroup) => {
        if (segmentGroup.id !== payload.id) {
          return segmentGroup;
        }
        return payload;
      });

      const activeSegmentGroups = newSegmentGroups.filter((segmentGroup: SegmentGroupTypes) => {
        return segmentGroup.segmentType === state.activeSegmentType;
      });

      return {
        ...state,
        segmentGroups: newSegmentGroups,
        activeSegmentGroups,
      };
    }
    case FAILURE_UPDATE_SEGMENT_GROUP: {
      return {
        ...state,
      };
    }
    case REQUEST_INACTIVATE_SEGMENT_GROUP: {
      return {
        ...state,
      };
    }
    case SUCCESS_INACTIVATE_SEGMENT_GROUP: {
      const { payload } = action;

      const segmentGroups = state.segmentGroups.filter((segmentGroup) => {
        return segmentGroup.id !== payload.id;
      });

      const activeSegmentGroups = segmentGroups.filter((segmentGroup: SegmentGroupTypes) => {
        return segmentGroup.segmentType === state.activeSegmentType;
      });

      return {
        ...state,
        segmentGroups,
        activeSegmentGroups,
      };
    }
    case FAILURE_INACTIVATE_SEGMENT_GROUP: {
      return {
        ...state,
      };
    }
    case REQUEST_SORT_SEGMENT_GROUP: {
      return {
        ...state,
      };
    }
    case SUCCESS_SORT_SEGMENT_GROUP: {
      const { payload } = action;

      const activeSegmentGroups = payload.filter((segmentGroup: SegmentGroupTypes) => {
        return segmentGroup.segmentType === state.activeSegmentType;
      });

      return {
        ...state,
        segmentGroups: payload,
        activeSegmentGroups,
      };
    }
    case FAILURE_SORT_SEGMENT_GROUP: {
      return {
        ...state,
      };
    }
    default: {
      return state;
    }
  }
};

export default backendSegmentReducer;
